"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.draw = exports.slide = exports.scale = exports.fly = exports.blur = exports.fade = exports.forCustomElement = void 0;
const transition_1 = require("svelte/transition");
/**
 * @method Convert a svelte transition into a form that works for custom elements
 * @param original A transition function which works with vanilla Svelte
 * @returns A new transition function that works with custom elements made with Svelte
 */
function forCustomElement(original) {
    return (node, params) => {
        const o = original(node, params);
        const config = Object.assign({}, o);
        config.tick = (t, u) => {
            if (o.tick)
                o.tick(t, u);
            const css = o.css ? o.css(t, u) : '';
            node.style.cssText += css;
        };
        return config;
    };
}
exports.forCustomElement = forCustomElement;
exports.fade = forCustomElement(transition_1.fade);
exports.blur = forCustomElement(transition_1.blur);
exports.fly = forCustomElement(transition_1.fly);
exports.scale = forCustomElement(transition_1.scale);
exports.slide = forCustomElement(transition_1.slide);
exports.draw = forCustomElement(transition_1.draw);
